import React from 'react';
import PropTypes from 'prop-types';

const EstadisticasOrdenButton = ({ ordenId, onOpenModal, loading = false }) => {
  const handleClick = () => {
    if (onOpenModal && !loading) {
      onOpenModal(ordenId);
    }
  };

  return (
    <button
      type="button"
      className="btn btn-info btn-sm"
      onClick={handleClick}
      disabled={loading}
      data-testid={`estadisticas-btn-${ordenId}`}
      title="Ver estadísticas de la orden"
    >
      {loading ? (
        <>
          <span 
            className="spinner-border spinner-border-sm me-1" 
            role="status" 
            aria-hidden="true"
            data-testid="loading-spinner"
          />
          Cargando...
        </>
      ) : (
        <>
          <i 
            className="fas fa-chart-line me-1" 
            data-testid="estadisticas-icon"
            aria-hidden="true"
          />
          Estadísticas
        </>
      )}
    </button>
  );
};

EstadisticasOrdenButton.propTypes = {
  /** ID de la orden de producción */
  ordenId: PropTypes.string.isRequired,
  /** Función callback que se ejecuta al hacer clic en el botón */
  onOpenModal: PropTypes.func,
  /** Estado de carga del botón */
  loading: PropTypes.bool
};

EstadisticasOrdenButton.defaultProps = {
  onOpenModal: null,
  loading: false
};

export default EstadisticasOrdenButton;
